import React, { FC, useEffect, useState } from 'react'
import { ModuleNames } from '../../../../constants/componentNames.constants'
import { TopicFaq } from '../../../../models/topics/faq'
import { RichTextWrapper } from '../../../../styles/global'
import { renderRichText } from '../../../../utils/richTextHandler.utils'
import Typography from '../../typography'

type Props = {
  data: TopicFaq
  idx: number
  toggleDrawer: any
}

export const FAQ: FC<Props> = ({ data, idx, toggleDrawer }) => {
  if (!data) return null
  const [openFAQFromHash, setOpenFAQFromHash] = useState(false)
  const title = data.title?.title || data.title || ''
  const body = data.body || ''

  useEffect(() => {
    const firstReference = body?.references || []
    if (
      firstReference[0]?.__typename === ModuleNames.ANCHOR_LINK &&
      firstReference[0]?.identifier
    ) {
      if (typeof window !== 'undefined') {
        if (window.location.hash === `#${body.references[0].identifier}`) {
          setOpenFAQFromHash(true)
        }
      }
    }
  }, [])

  useEffect(() => {
    if (openFAQFromHash) {
      //* scrollOffSet includes height of page Sticky Nav and height of faq title header
      if (typeof window !== 'undefined') {
        const scrollOffSet = window.innerWidth <= 1025 ? 222 : window.innerWidth <= 1280 ? 272 : 322
        const anchorLink = window.document.getElementById(body.references[0].identifier)

        if (anchorLink) {
          const y = anchorLink.getBoundingClientRect().top + window.scrollY - scrollOffSet
          window.scroll({
            top: y,
            behavior: 'smooth',
          })
        }
      }
    }
  }, [openFAQFromHash])

  return (
    <li
      {...(idx === 0 && {
        className: 'FAQ-Item__Active--Desktop',
      })}
      key={`FAQ-Item__Menu-${idx}`}
      className={`FAQ__Item-Container ${openFAQFromHash ? 'FAQ-Item__Active' : ''}`}
      onClick={() => {
        toggleDrawer(idx)
      }}>
      <div className="FAQ__Item">
        {title && (
          <div className="FAQ__Item-Header-Container">
            <Typography type="header6" className="FAQ-Item__Label">
              {title}
            </Typography>
          </div>
        )}

        {body && (
          <div className="FAQ__Item-Body FAQ-Item__Accordion-Item">
            <RichTextWrapper $type="body" className="FAQ-Item__Item-Body font__inter">
              {renderRichText(body)}
            </RichTextWrapper>
          </div>
        )}
      </div>
    </li>
  )
}
